import { FALLBACK_IMAGE } from "../../utils/uiConstants";
import { resolveProductImage } from "../../features/catalog/utils/catalogUtils";

export const sanitizeText = (value = "") =>
    String(value)
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();

export const toRelatedItem = (product) => {
    return {
        code: sanitizeText(product?.codigo || ""),
        name: sanitizeText(product?.descripcion || ""),
        image: resolveProductImage(product?.foto, product?.mime) || FALLBACK_IMAGE,
    };
};

export const toObraOption = (obra) => ({
    id: String(obra?.id ?? "").trim(),
    nombre: String(obra?.nombre || obra?.descripcion || "").trim(),
});

export const mapDetalleToCartItems = (detalleJson) => {
    const detalles = Array.isArray(detalleJson?.detalles) ? detalleJson.detalles : [];

    return detalles.map((d) => {
        const cantidad = Number(d?.cantidad || 0);
        const unitPrice = d?.valorUnitario ;
        const image = resolveProductImage(d?.foto, d?.mime);
        const code = String(d?.codigo || "");
        const warehouse = d?.almacen || "";

        return {
            code,
            name: String(d?.glosa || ""),
            price: Number.isFinite(unitPrice) ? unitPrice : 0,
            quantity: Number.isFinite(cantidad) ? cantidad : 0,
            warehouse,
            lineKey: `${code}::${warehouse}`,
            backendDetailId: d?.id != null ? String(d.id) : null,
            image,
        };
    });
};

export const formatResumenValue = (value, currencyFormatter, fallback = "-") => {
    if (value === undefined || value === null || value === "") return fallback;
    if (typeof value === "number") return currencyFormatter.format(value);
    return String(value);
};

export const sumCartTotal = (items = []) =>
    items.reduce((acc, item) => acc + Number(item.price || 0) * Number(item.quantity || 0), 0);
